import { Entities, fetchAll, fetchByCompanyId, fetchById, patch, Projection, save } from 'src/common/index';
import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import ErrorMessage from 'src/components/misc/error-message';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { setSliderIndex } from 'src/actions/form';
import CustomerGroupSettingsEditForm from 'src/components/administration/customer-group/customer-group-settings-edit-form';

class CustomerGroupSettingsEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { customerGroupSettings, duplicate, isCreate, selectedCompany, t } = this.props;

        const finishFetching = true;

        if (finishFetching) {
            if (customerGroupSettings === undefined) return <ErrorMessage object={customerGroupSettings} />;
            else {
                let initialValues = {
                    id: duplicate ? undefined : customerGroupSettings.id,
                    groupOfPersonsNotTransported: customerGroupSettings.groupOfPersonsNotTransported,
                    invoicePaymentEnabled: customerGroupSettings.invoicePaymentEnabled,
                };
                return (
                    <CustomerGroupSettingsEditForm
                        t={t}
                        initialValues={initialValues}
                        isCreate={isCreate}
                        onSubmit={this.handleSubmit}
                        selectedCompany={selectedCompany}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { handleClose } = this.props;

        this.props.patch(data, Entities.CUSTOMER_GROUP_SETTINGS, this.props.selectedCompany, Projection.FULL, null);
        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        busCompany: getOwnCompany(state),
        selectedCompany: state.selectedCompany,
    };
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        fetchAll,
        fetchByCompanyId,
        save,
        patch,
        setSliderIndex,
    },
    null,
    { withRef: true },
)(CustomerGroupSettingsEditModal);
